import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-salon',
  templateUrl: './salon.component.html',
  styleUrls: ['./salon.component.css']
})
export class SalonComponent implements OnInit {
  activeView = 'venta';
  sucId = 1;
  today = this.toDateInput(new Date());
  loading = false;
  userRole = '';
  userName = '';

  dashboard: any = {};
  lowStock: any[] = [];
  servicios: any[] = [];
  productos: any[] = [];
  trabajadores: any[] = [];
  metodosPago: any[] = [];
  categoriasServicio: any[] = [];
  categoriasProducto: any[] = [];
  especialidades: any[] = [];
  roles: any[] = [];
  usuarios: any[] = [];
  clientes: any[] = [];
  private metodosPagoBase = [
    { id: 1, nombre: 'EFECTIVO' },
    { id: 2, nombre: 'YAPE' },
    { id: 3, nombre: 'PLIN' },
    { id: 4, nombre: 'TARJETA' },
    { id: 5, nombre: 'TRANSFERENCIA' }
  ];

  constructor(private api: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.userRole = String(sessionStorage.getItem('rol_nombre') || '').toUpperCase();
    this.userName = String(sessionStorage.getItem('usu_nomcom') || sessionStorage.getItem('usu_nombre') || 'USUARIO');
    this.activeView = this.defaultViewByRole();
    this.loadAll();
  }

  loadAll(): void {
    this.loading = true;
    this.loadDashboard();
    this.loadCatalogs();
    this.loadOperativeData();
  }

  loadDashboard(): void {
    this.api.salonDashboard({ p_suc_id: this.sucId, p_fecha: this.today }).subscribe((data: any) => {
      if (Array.isArray(data)) {
        this.dashboard = data[0] || {};
        this.lowStock = data[1] || [];
      }
      this.loading = false;
    }, () => this.loading = false);
  }

  loadCatalogs(): void {
    this.api.salonCatalogo({ p_catalogo: 'METODOS_PAGO' }).subscribe((data: any) => {
      const rows = this.normalizeRows(data);
      const raw = rows.length ? rows : this.metodosPagoBase;
      this.metodosPago = raw.map((m: any) => ({
        id: Number(m.id || m.mpa_id || 1),
        nombre: String(m.nombre || m.mpa_nombre || 'EFECTIVO'),
        mpa_id: Number(m.id || m.mpa_id || 1),
        mpa_nombre: String(m.nombre || m.mpa_nombre || 'EFECTIVO')
      }));
    }, (err) => {
      this.metodosPago = this.metodosPagoBase;
      this.logSalonLoadError('METODOS_PAGO', err);
    });
    this.api.salonCatalogo({ p_catalogo: 'CATEGORIA_SERVICIO' }).subscribe((data: any) => this.categoriasServicio = this.normalizeRows(data), (err) => this.logSalonLoadError('CATEGORIA_SERVICIO', err));
    this.api.salonCatalogo({ p_catalogo: 'CATEGORIA_PRODUCTO' }).subscribe((data: any) => this.categoriasProducto = this.normalizeRows(data), (err) => this.logSalonLoadError('CATEGORIA_PRODUCTO', err));
    this.api.salonCatalogo({ p_catalogo: 'ESPECIALIDADES' }).subscribe((data: any) => this.especialidades = this.normalizeRows(data), (err) => this.logSalonLoadError('ESPECIALIDADES', err));
    this.api.salonRolesLis().subscribe((data: any) => this.roles = this.normalizeRows(data), (err) => this.logSalonLoadError('ROLES', err));
  }

  loadOperativeData(): void {
    this.api.salonServicioLis({ p_csv_id: 0, p_activo: 1 }).subscribe((data: any) => this.servicios = this.normalizeRows(data), (err) => this.logSalonLoadError('SERVICIOS', err));
    this.api.salonProductoLis({ p_cat_id: 0, p_activo: 1 }).subscribe((data: any) => this.productos = this.normalizeRows(data), (err) => this.logSalonLoadError('PRODUCTOS', err));
    this.api.salonTrabajadorLis({ p_suc_id: this.sucId, p_activo: null }).subscribe((data: any) => this.trabajadores = this.normalizeRows(data), (err) => this.logSalonLoadError('TRABAJADORES', err));
    this.api.salonUsuarioLis({}).subscribe((data: any) => this.usuarios = this.normalizeRows(data), (err) => this.logSalonLoadError('USUARIOS', err));
    this.api.salonClienteLis({ p_buscar: '', p_activo: 1 }).subscribe((data: any) => this.clientes = this.normalizeRows(data), (err) => this.logSalonLoadError('CLIENTES', err));
  }

  refreshAfterMutation(): void {
    this.loadDashboard();
    this.loadOperativeData();
  }

  setView(view: string): void {
    if (!this.canAccessView(view)) {
      this.activeView = this.defaultViewByRole();
      return;
    }
    this.activeView = view;
  }

  canAccessView(view: string): boolean {
    const allowed = this.allowedViews();
    return allowed.indexOf(view) >= 0;
  }

  roleLabel(): string {
    return this.userRole || 'USUARIO';
  }

  roleMessage(): string {
    const messages: {[key: string]: string} = {
      ADMINISTRADOR: 'Acceso completo a ventas, caja, gestión y reportes.',
      RECEPCIONISTA: 'Enfoque en registrar personas en lobby y asignar servicios.',
      CAJERO: 'Enfoque en cobros, caja, egresos, cierres y reportes.',
      ESTILISTA: 'Enfoque en revisar producción y servicios realizados.',
      MANICURISTA: 'Enfoque en producción de manicure/pedicure y servicios realizados.'
    };
    return messages[this.userRole] || 'Acceso personalizado al salón.';
  }

  logout(): void {
    sessionStorage.clear();
    window.location.replace('/login');
  }

  private allowedViews(): string[] {
    const viewsByRole: {[key: string]: string[]} = {
      ADMINISTRADOR: ['venta', 'gestion', 'reportes'],
      RECEPCIONISTA: ['venta'],
      CAJERO: ['venta', 'reportes'],
      ESTILISTA: ['reportes'],
      MANICURISTA: ['reportes']
    };
    return viewsByRole[this.userRole] || ['venta'];
  }

  private defaultViewByRole(): string {
    return this.allowedViews()[0] || 'venta';
  }

  private normalizeRows(data: any): any[] {
    if (data && data.data) {
      return this.normalizeRows(data.data);
    }

    if (Array.isArray(data)) {
      if (Array.isArray(data[0])) {
        return this.normalizeRows(data[0]);
      }
      return data.map(item => this.normalizeCatalogRow(item));
    }
    return [];
  }

  private normalizeCatalogRow(item: any): any {
    if (!item || typeof item !== 'object') {
      return item;
    }
    const id = item.id || item.mpa_id || item.csv_id || item.cat_id || item.esp_id || item.rol_id;

    return Object.assign({}, item, {
      id: Number(id),
      nombre: item.nombre || item.mpa_nombre || item.csv_nombre || item.cat_nombre || item.esp_nombre || item.rol_nombre
    });
  }

  private logSalonLoadError(label: string, err: any): void {
    console.error(`[SALON] No se pudo cargar ${label}`, err);
  }

  private toDateInput(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }
}
